import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that accepts either an object or an array of objects with a `uniqueId` property
 * and returns a string or an array of strings (unique IDs).
 */
@Pipe({
  name: 'mapToUniqueId',
  standalone: true,
})
export class MapToUniqueIdPipe implements PipeTransform {
  public transform<T extends { uniqueId: string } | { uniqueId: string }[]>(value: T): string | string[] | undefined {
    if (Array.isArray(value)) {
      return value.map((element) => element.uniqueId);
    } else if (value && typeof value === 'object' && 'uniqueId' in value) {
      return value.uniqueId;
    }
    return undefined;
  }
}
